import { useEffect, useState } from 'react';
/**
 * This is used to differentiate between Server and Client Environments.
 * @returns whether the Browser DOM is available
 * @notes This is a function to guarantees the evaluation is performed at function execution and not when the script is interpreted, which is a little vague especially in SSR context.
 */
export const isDOMAvailable = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * useSSR
 * - Hook providing a check for server-side or client-side rendering
 * @param {boolean} initialIsBrowser DEPRECATED: This is no longer used. Will be removed in next major release
 * @returns `isBrowser` if there is a window global present, and `isServer` as the opposite for semantic convenience
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useSSR = (initialIsBrowser) => {
    const [isBrowser, setIsBrowser] = useState(isDOMAvailable());
    useEffect(() => {
        setIsBrowser(isDOMAvailable());
        return () => {
            setIsBrowser(false);
        };
    }, []);
    return { isBrowser, isServer: !isBrowser };
};
